import React from "react";
import { INGREDIENTS } from "@/data/catalog";
import { DynIcon } from "@/components/DynIcon";
import { SectionHeading } from "@/components/home/SectionHeading";

export const Ingredients = () => (
  <section className="bg-[#E9E2D6]/50 py-16 md:py-24" data-testid="ingredients">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        overline="Ingredients"
        title="Thoughtfully gentle, naturally derived"
        subtitle="Fragrance-free formulas made with skin-loving ingredients you can feel good about."
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="rounded-3xl aspect-[4/3] bg-gradient-to-b from-[#F8F5EF] to-[#E9E2D6]/60 flex items-center justify-center p-8">
          <img
            src="/assets/ingredients.png"
            alt="Hemp seed oil, shea butter, oats and hemp seeds"
            loading="lazy"
            className="w-full h-full object-contain drop-shadow-[0_20px_30px_rgba(111,80,58,0.12)]"
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {INGREDIENTS.map((ing) => (
            <div
              key={ing.name}
              data-testid={`ingredient-${ing.name}`}
              className="bg-white rounded-3xl p-6 shadow-[0_4px_24px_rgba(111,80,58,0.05)]"
            >
              <div className="w-11 h-11 rounded-2xl bg-[#B8C4A3]/20 flex items-center justify-center mb-4">
                <DynIcon name={ing.icon} className="w-5 h-5 text-[#6F503A]" />
              </div>
              <h3 className="font-heading font-semibold text-[#6F503A] mb-1.5">{ing.name}</h3>
              <p className="text-sm text-[#6F503A]/70 leading-relaxed">{ing.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
